import {Component, inject, ViewChild} from '@angular/core';
import {ModalComponent} from '../../modal.component';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputComponent} from '../../../form/input/input.component';
import {ButtonComponent} from '../../../button/button.component';

@Component({
  selector: 'app-send-sms-code',
  imports: [
    ModalComponent,
    ReactiveFormsModule,
    InputComponent,
    ButtonComponent
  ],
  templateUrl: './send-sms-code.component.html',
})
export class SendSmsCodeComponent {

  @ViewChild('modalComponent')
  modal: ModalComponent<SendSmsCodeComponent>;

  formBuilder = inject(FormBuilder)
  smsCodeForm = this.formBuilder.group({
    code: [null, Validators.compose([Validators.required, Validators.minLength(6)])],
  })

  send() {
    this.modal.close(this.smsCodeForm.controls.code.value);
  }

}
